<template>
  <div>
    <Bar :data="chartData" :options="options" />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Bar } from "vue-chartjs";

export default defineComponent({
  name: "PlottedBarChart",
  components: { Bar },
  props: ["chartData"],
  // mixins: [mixins.reactiveProp],
  data() {
    return {
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: true,
            labels: {
              usePointStyle: true,
            },
          },
          tooltips: {
            intersect: false,
            displayColors: true,
            mode: "index",
          },
        },

        legend: {
          display: false,
        },
        maxBarThickness: 30,
        maintainAspectRatio: false,
        layout: {
          padding: {
            left: 10,
            right: 10,
            top: 10,
            bottom: 10,
          },
        },

        scales: {
          y: {
            ticks: {
              beginAtZero: true,
              fontSize: 10,
              fontColor: "#6C757D",
              maxTicksLimit: 4,
              suggestedMin: 3,
              padding: 10,
            },
            stacked: true,
            grid: {
              drawTicks: false,
              drawBorder: true,
              display: false,
              offsetGridLines: true,
            },
          },
          x: {
            maxBarThickness: 100,
            stacked: true,
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              // maxRotation: 0,
              fontSize: 10,
              // maxTicksLimit: 3,
              fontColor: "#6C757D",
            },
          },
        },
      },
    };
  },
});
</script>
<style scoped>
canvas {
  height: 100% !important;
  width: 100% !important;
}
</style>
